import React from "react";
import { type FreefieldInputProps } from "shared/utils/freeFields/models";
import { Input } from "semantic-ui-react";
import { blurAndSubmitOnEnter } from "utilities/reactUtils";

const FreefieldTextSingleLine = (props: FreefieldInputProps) => {
  const [text, setText] = React.useState(props.initialValue ?? "");

  return <Input
    value={text}
    onChange={(_, { value }) => { setText(value); }}
    onBlur={() => { props.onChange(text); }}
    maxLength={serverReference.constants.freeField.maxSingleLineTextLength}
    fluid
    onKeyDown={blurAndSubmitOnEnter}
    name={props.reference}
  />;
};

export default FreefieldTextSingleLine;